module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/service-information.component.css
// module id = ./src/app/service-information.component.css
// module chunks = main